/* ===================== PRODUCT VARIANT SELECTOR ===================== */

window.ProductVariantSelector = (function ($) {
  "use strict";

  class ProductVariantSelector {
    constructor() {
      this.isSubscriptionActive = false;
      this.discountPercentage = 15;

      // Initialize currency - will be set when DOM is ready
      this.currencyRaw = "$0.00";
      this.currency = "$";

      // Initialize logging
      this.log = window.log || console;

      this.init();
    }

    init() {
      this.initializeCurrency();
      this.bindEvents();
      this.updateSubscriptionState();
      this.initializePrices();
      this.handleUrlVariant();
    }

    initializeCurrency() {
      // Get currency from DOM when it's available
      const currencyData = $(".pr-selector__variants").data("currency");
      if (currencyData) {
        this.currencyRaw = currencyData;
        this.currency =
          this.currencyRaw
            .replace(/<span[^>]*>|<\/span>/g, "")
            .replace(/[\d.,\s]/g, "") || "$";
      }
    }

    initializePrices() {
      // Update all prices on initial load based on subscription state
      this.updateVariantSelectorPrices();

      // Update main product price if there's a selected variant
      const $activeVariant = $(".pr-selector__variant.active");
      if ($activeVariant.length) {
        const variantData = this.getVariantData($activeVariant);
        this.updatePricing(variantData);
      }
    }

    bindEvents() {
      // Handle variant selection clicks
      $(document).on("click", ".pr-selector__variant", (e) => {
        e.preventDefault();
        this.selectVariant($(e.currentTarget));
      });

      // Handle subscription toggle
      $(document).on("click", ".pp_var_autoship", (e) => {
        e.preventDefault();
        this.toggleSubscription();
      });
    }

    selectVariant($variant) {
      const variantData = this.getVariantData($variant);
      this.log.collapse(
        {
          variantId: variantData.variantId,
          option1: variantData.option1,
          option2: variantData.option2,
          price: variantData.optionPrice,
        },
        "Selected Variant",
        "success"
      );

      // Update active state
      this.updateActiveState($variant);

      // Update form inputs
      this.updateFormInputs(variantData);

      // Update product select dropdown
      this.updateProductSelect(variantData);

      // Update pricing display
      this.updatePricing(variantData);

      // Update variant selector prices
      this.updateVariantSelectorPrices();
    }

    getVariantData($variant) {
      return {
        variantId: $variant.data("variant-id"),
        option1: $variant.data("option1"),
        option2: $variant.data("option2"),
        optionIndex: $variant.data("option-index"),
        optionPrice: $variant.data("option-price"),
        optionCprice: $variant.data("option-cprice"),
        optionSaveprice: $variant.data("option-saveprice"),
        optionSavepricestr: $variant.data("option-savepricestr"),
        variantQuantity: $variant.data("variant-quantity"),
      };
    }

    updateActiveState($variant) {
      $(".pr-selector__variant.active").removeClass("active");
      $variant.addClass("active");
    }

    updateFormInputs(variantData) {
      const optionValue = variantData.option2 || variantData.option1;

      // Update radio inputs (without triggering change to avoid currency conversion issues)
      if ($(".adev-product-options input").length) {
        $(
          `input[data-index="${variantData.optionIndex}"][value="${optionValue}"]`
        ).prop("checked", true);
      }

      // Update select inputs (without triggering change to avoid currency conversion issues)
      if ($(".adev-product-options select").length) {
        $(`select[data-index="${variantData.optionIndex}"]`).val(optionValue);
      }
    }

    updateProductSelect(variantData) {
      const $productSelect = $(".product-single__variants");
      if ($productSelect.length) {
        // Remove selected from all options
        $productSelect.find("option").prop("selected", false);
        // Set selected on the correct option
        $productSelect
          .find(`option[value="${variantData.variantId}"]`)
          .prop("selected", true);
        // Update the select value
        $productSelect.val(variantData.variantId);
      }

      // Update URL parameter
      this.updateUrlParameter(variantData.variantId);
    }

    updatePricing(variantData) {
      console.log(variantData);
      let price = variantData.optionPrice / 100; // Convert from cents

      // Apply discount if subscription is active
      if (this.isSubscriptionActive) {
        price = this.applyDiscount(price, this.discountPercentage);
      }

      // Format price with currency
      const formattedPrice = this.formatPrice(price);

      // Update main product price
      $("#ProductPrice").html(formattedPrice);

      // Update compare at price
      // $("#ComparePrice").hide();
      // $("#ComparePrice").show();
      var selectedVariantId = variantData.variantId;
      var fullPrice = $(
        '.pr-selector__variant[data-variant-id="' + selectedVariantId + '"]'
      ).attr("data-option-cprice");

      var fullpriceEur = parseFloat(fullPrice / 100);
      console.log(selectedVariantId, fullpriceEur, price, "FULL PRICE IS");
      $("#ComparePrice").html(this.formatPrice(fullPrice / 100));

      $("#ComparePrice").removeClass("hide");
      if (price < fullpriceEur) {
      } else {
        $("#ComparePrice").addClass("hide");
      }

      // if (variantData.optionCprice !== "" && variantData.optionCprice > 0) {
      //   $("#ComparePrice").show();
      //   $("#ComparePrice").html(
      //     this.formatPrice(variantData.optionCprice / 100)
      //   );
      // }

      // Update save label
      this.updateSaveLabel(variantData);
    }

    updateSaveLabel(variantData) {
      if (variantData.optionSaveprice > 0) {
        $(".product_single--save_label").removeClass("saveprice");
        $(".product_single--save_label").html(
          "save " + this.formatPrice(variantData.optionSavepricestr / 100)
        );
      } else {
        $(".product_single--save_label").addClass("saveprice");
      }
    }

    updateVariantSelectorPrices() {
      $(".pr-selector__variant").each((index, element) => {
        const $variant = $(element);

        // Update main price
        const originalPrice = $variant.data("option-price") / 100; // Convert from cents
        const newPrice = this.isSubscriptionActive
          ? this.applyDiscount(originalPrice, this.discountPercentage)
          : originalPrice;
        $variant
          .find(".pr-selector__variant-price")
          .text(this.formatPrice(newPrice));

        // Update compare at price
        const comparePrice = $variant.data("option-cprice") / 100; // Convert from cents
        if (comparePrice > originalPrice) {
          $variant
            .find(".pr-selector__variant-prices s")
            .text(this.formatPrice(comparePrice));
        }

        // Update price per quantity
        const pricePerQuantity = $variant.data("price-per-quantity");
        if (pricePerQuantity) {
          // Convert from cents to dollars
          const numericValue = pricePerQuantity / 100;
          const discountedValue = this.isSubscriptionActive
            ? this.applyDiscount(numericValue, this.discountPercentage)
            : numericValue;
          // Ensure we have a number before calling toFixed
          const finalValue =
            typeof discountedValue === "number"
              ? discountedValue
              : parseFloat(discountedValue);
          $variant
            .find(".price_per_quantity")
            .text(this.currency + finalValue.toFixed(2));
        }
      });
    }

    toggleSubscription() {
      $(".pp_var_autoship").toggleClass("disabled");
      this.isSubscriptionActive = !$(".pp_var_autoship").hasClass("disabled");

      // Trigger bundle option changes
      if (this.isSubscriptionActive) {
        $('.pp_bundle_option[mode="sub"]').find("input").trigger("click");
      } else {
        $('.pp_bundle_option[mode="otp"]').find("input").trigger("click");
      }

      // Update all prices
      this.updateAllPrices();
    }

    updateAllPrices() {
      // Update main product price
      const mainId =
        $(".product-single__variants").val() ||
        new URLSearchParams(window.location.search).get("variant");
      const $subsDetails = $(`.pp_var-subs-details[data-id="${mainId}"]`);

      if ($subsDetails.length) {
        const newPrice = this.isSubscriptionActive
          ? $subsDetails.attr("data-sub-price")
          : $subsDetails.attr("data-price");
        $("#ProductPrice").html(`<span class="money_">${newPrice}</span>`);

        var selectedVariantIndex = $(".pr-selector__variant.active").attr(
          "data-variant-quantity"
        );

        if (selectedVariantIndex == "1") {
          if ($(".pp_var_autoship").hasClass("disabled")) {
            $("#ComparePrice").addClass("hide");
          } else {
            $("#ComparePrice").removeClass("hide");
          }
        } else {
          $("#ComparePrice").removeClass("hide");
        }
      }

      // Update variant selector prices
      this.updateVariantSelectorPrices();
    }

    updateSubscriptionState() {
      this.isSubscriptionActive = !$(".pp_var_autoship").hasClass("disabled");
    }

    handleUrlVariant() {
      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get("variant");

      if (variantId) {
        const $variant = $(
          `.pr-selector__variant[data-variant-id="${variantId}"]`
        );
        if ($variant.length) {
          $variant.trigger("click");
        }
      } else if ($(".pr-selector__variant.adev-popular").length) {
        $(".pr-selector__variant.adev-popular").trigger("click");
      }
    }

    formatPrice(price) {
      // Convert to number if it's a string
      const numericPrice =
        typeof price === "string" ? parseFloat(price) : price;

      // Format with currency
      return this.currency + numericPrice.toFixed(2);
    }

    applyDiscount(value, discount = 15) {
      // Handle raw numeric values
      const numericValue =
        typeof value === "string" ? parseFloat(value) : value;
      const discounted = numericValue * (1 - discount / 100);
      return discounted;
    }

    updateUrlParameter(variantId) {
      // Use setTimeout to ensure URL update happens after other operations
      setTimeout(() => {
        const url = new URL(window.location);
        url.searchParams.set("variant", variantId);
        window.history.replaceState({}, "", url);
      }, 10);
    }
  }

  // Initialize when document is ready
  $(document).ready(() => {
    new ProductVariantSelector();
    setTimeout(function () {
      $(".pr-selector__variant.active").trigger("click");
    });
  });

  return ProductVariantSelector;
})(jQuery);
